
import React, {useEffect, useState, useMemo, useCallback} from 'react';
import {BrowserRouter as Router, Switch} from 'react-router-dom';
import Main from '@modules/main/Main';
import Login from '@modules/login/Login';
import Register from '@modules/register/Register';
import ForgetPassword from '@modules/forgot-password/ForgotPassword';
import RecoverPassword from '@modules/recover-password/RecoverPassword';
import PrivacyPolicy from '@modules/privacy-policy/PrivacyPolicy';
import {useWindowSize} from '@app/hooks/useWindowSize';
import {calculateWindowSize} from '@app/utils/helpers';
import {useDispatch, useSelector} from 'react-redux';
import {setWindowSize} from '@app/store/reducers/ui';

import PublicRoute from './routes/PublicRoute';
import PrivateRoute from './routes/PrivateRoute';

import './App.scss';
import $ from 'jquery';
window.$ = window.jQuery = $;

const App = () => {
    const windowSize = useWindowSize();
    const screenSize = useSelector((state) => state.ui.screenSize);
    const dispatch = useDispatch();

    const [isTokenFound, setTokenFound] = useState(false);

    // Memoize the calculated size to prevent unnecessary recalculations
    const calculatedSize = useMemo(() => {
        return calculateWindowSize(windowSize.width);
    }, [windowSize.width]);

    // Memoize the dispatch function to prevent unnecessary re-renders
    const updateScreenSize = useCallback((newSize) => {
        dispatch(setWindowSize(newSize));
    }, [dispatch]);

    // Effect for handling window size changes
    useEffect(() => {
        // Only update if the calculated size is different from current screen size
        if (screenSize !== calculatedSize) {
            console.log(`Screen size changed: ${screenSize} → ${calculatedSize}`);
            updateScreenSize(calculatedSize);
        }
    }, [calculatedSize, screenSize, updateScreenSize]);

    // Separate effect for token initialization (runs only once)
    useEffect(() => {
        const initializeApp = async () => {
            try {
                // Uncomment if you need Firebase token:
                // await getFirebaseToken(setTokenFound);
                console.log('App initialized');
            } catch (error) {
                console.error('App initialization failed:', error);
            }
        };

        initializeApp();
    }, []); // Empty dependency - runs only on mount

    // Memoize the router content to prevent unnecessary re-renders
    const routerContent = useMemo(() => (
        <Switch>
            <PublicRoute exact path="/login">
                <Login />
            </PublicRoute>
            <PublicRoute exact path="/register">
                <Register />
            </PublicRoute>
            <PublicRoute exact path="/forgot-password">
                <ForgetPassword />
            </PublicRoute>
            <PublicRoute exact path="/recover-password">
                <RecoverPassword />
            </PublicRoute>
            <PublicRoute exact path="/privacy-policy">
                <PrivacyPolicy />
            </PublicRoute>
            <PublicRoute exact path="/callback">
                <h1>Callback</h1>
            </PublicRoute>
            <PrivateRoute path="/">
                <Main />
            </PrivateRoute>
        </Switch>
    ), []); // No dependencies - routes don't change

    return (
        <Router>
            {routerContent}
        </Router>
    );
};

export default App;